import React, { useState } from "react";
import { apiCall } from "../utils/Api";
import Comment from "./Comment";
import { Button, Space } from "antd";
import { useSession } from "../utils/Session";
export default function Comments(props) {

    const { eisbn = "", row = false, comments = false, titlelist_id = "" } = props;
    const [results, setResults] = useState((comments) ? comments : []);
    const [session, setSession] = useSession(); 

    const getComments = () => {
        let request = {};
        request.eisbn = eisbn;
        if (titlelist_id) {
            request.titlelist_id = titlelist_id;
        }
        apiCall("title/getComments", request, (_status, _result) => {
            if (_status) {
                setResults(_result);
            }
        })
    }

    const drawComments = () => {
        if (results.length < 1) {
            return (<></>)
        }

        return results.sort((a, b) => b.modified - a.modified).map((item, index) => {
            return (
                <div key={index}>
                    <Comment.Display callback={getComments} eisbn={eisbn} titlelist_id={titlelist_id} key={index} data={item} />
                    {((index + 1) !== results.length) && <><div className="shim"></div><div className="shim"></div></>}
                </div>
            )
        })
    }

    if (row) {
        return (
            <>
          
                {(session.has_bm_data_full &&
                    <div>
                        <Space>
                            <Comment titlelist_id={titlelist_id} eisbn={eisbn} opennew data={{ text: "" }} callback={getComments} >
                                <Button className="mini-btn" size="small"><small>New Comment</small></Button>
                            </Comment>
                        </Space>
                        <div className="shim" /><div className="shim" />
                    </div>
                )}
                
                <div style={{ "padding": "0px" }}>
                    <div className="shim" />
                    {drawComments()}
                    <div className="shim" />
                </div>
            </>
        )
    }

    return (<>
        <div style={{ "padding": "0px" }}>
            <div className="shim" />
            {drawComments()}
            <div className="shim" />
        </div>
    </>
    )



}